import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface KsefTokenDialogData {
  hasToken: boolean;
  nip?: string;
}

export interface KsefTokenDialogResult {
  token: string;
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule
  ],
  selector: 'app-ksef-token-dialog',
  templateUrl: './ksef-token-dialog.component.html',
  styleUrls: ['./ksef-token-dialog.component.scss']
})
export class KsefTokenDialogComponent {
  tokenControl = new FormControl('', [Validators.required, Validators.minLength(10)]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: KsefTokenDialogData,
    private dialogRef: MatDialogRef<KsefTokenDialogComponent, KsefTokenDialogResult>
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.tokenControl.valid && this.tokenControl.value) {
      this.dialogRef.close({ token: this.tokenControl.value });
    }
  }
}
